import React from 'react'

/**
 * COMPONENTE: PORTADA OVERLAY (VISUAL CHILD)
 * ------------------------------------------------------------------
 * Renderiza la pantalla/portada de la Tómbola.
 * Soporta fondo expandido (fullscreen) o centrado (vertical band).
 * Soporta fondo de color sólido, imagen o video en bucle.
 * ------------------------------------------------------------------
 */
const Portada = ({ config, windowScale = 1, isAdminPreview = false }) => {
    const {
        titleText,
        subtitleText,
        visible,
        expanded,
        bgType,
        bgColor,
        bgMediaUrl,
        logoDataUrl,
        logoScale,
        logoOffsetX,
        logoOffsetY,
        titleImgDataUrl,
        titleImgWidth,
        titleImgScale,
        titleOffsetX,
        titleOffsetY,
        titleSize,
        subtitleSize,
        scale
    } = config;

    if (!visible) return null;

    // Estilos dinámicos inyectados
    const containerStyle = {
        '--portada-bg-color': bgColor,
        '--portada-zoom': scale,
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden'
    };

    // Clases dinámicas
    const wrapperClasses = `portada-widget-wrapper ${expanded ? 'expanded' : 'centered-band'}`;

    return (
        <div className="portada-display-container" style={containerStyle}>
            <div className={wrapperClasses} style={{ width: expanded ? '100%' : '650px', height: '100%', position: 'relative' }}>
                
                {/* Capa de fondo (Color, Imagen o Video) */}
                <div className="portada-bg-layer">
                    {bgType === 'video' && bgMediaUrl && (
                        <video 
                            src={bgMediaUrl} 
                            autoPlay 
                            loop 
                            muted 
                            playsInline 
                            className="bg-media" 
                        />
                    )}
                    {bgType === 'image' && bgMediaUrl && (
                        <img 
                            src={bgMediaUrl} 
                            className="bg-media" 
                            alt="Fondo Portada" 
                        />
                    )}
                    {bgType === 'color' && (
                        <div className="bg-color-layer" style={{ backgroundColor: bgColor }} />
                    )}
                </div>

                {/* Contenido centrado de la portada */}
                <div className="portada-content-container" style={{ transform: `scale(${(scale ?? 1.0) * windowScale})`, transformOrigin: 'center center' }}>
                    
                    {/* Logotipo superior */}
                    {logoDataUrl ? (
                        <div 
                            className="portada-logo-wrapper"
                            style={{
                                position: 'relative',
                                left: `${logoOffsetX ?? 0}px`,
                                top: `${logoOffsetY ?? 0}px`,
                                transform: `scale(${logoScale ?? 1.0})`,
                                transformOrigin: 'center center',
                                transition: 'all 0.2s ease-out'
                            }}
                        >
                            <img src={logoDataUrl} className="portada-logo-img" alt="Logo Portada" />
                        </div>
                    ) : (
                        isAdminPreview && (
                            <div 
                                className="portada-logo-wrapper"
                                style={{
                                    position: 'relative',
                                    left: `${logoOffsetX ?? 0}px`,
                                    top: `${logoOffsetY ?? 0}px`,
                                    transform: `scale(${logoScale ?? 1.0})`,
                                    transformOrigin: 'center center',
                                    transition: 'all 0.2s ease-out',
                                    width: '120px',
                                    height: '80px',
                                    border: '2px dashed rgba(255, 255, 255, 0.4)',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    fontSize: '11px',
                                    background: 'rgba(0, 0, 0, 0.3)'
                                }}
                            >
                                <span>[Posición Logo]</span>
                            </div>
                        )
                    )}

                    {/* Título (Imagen o Texto) */}
                    <div
                        className="portada-title-wrapper"
                        style={{
                            position: 'relative',
                            left: `${titleOffsetX ?? 0}px`,
                            top: `${titleOffsetY ?? 0}px`,
                            transform: `scale(${titleImgScale ?? 1.0})`,
                            transformOrigin: 'center center',
                            transition: 'all 0.2s ease-out'
                        }}
                    >
                        {titleImgDataUrl ? (
                            <div className="portada-title-img-wrapper">
                                <img 
                                    src={titleImgDataUrl} 
                                    className="portada-title-img" 
                                    style={{ width: titleImgWidth ? `${titleImgWidth}px` : '500px', maxHeight: '350px', objectFit: 'contain', display: 'block', margin: '0 auto' }} 
                                    alt="Imagen de Título Portada" 
                                />
                            </div>
                        ) : (
                            titleText && (
                                <h1 className="portada-title-text" style={{ fontSize: titleSize ? `${titleSize}rem` : '4.8rem' }}>
                                    {titleText}
                                </h1>
                            )
                        )}
                    </div>

                    {/* Subtítulo (opcional) */}
                    {subtitleText && (
                        <h2 className="portada-subtitle-text" style={{ fontSize: subtitleSize ? `${subtitleSize}rem` : '2.2rem' }}>
                            {subtitleText}
                        </h2>
                    )}

                </div>

            </div>
        </div>
    );
};

export { Portada };
